import axios from 'axios';

const getApiBaseUrl = () => {
    // If REACT_APP_API_URL is set, use it (for custom deployments)
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;

    // Use relative path (empty string) to leverage proxy configuration
    // In development: proxy in package.json routes to http://localhost:5500
    // In production: nginx/web server should proxy /api to backend
    return '';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor - add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('vms_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid
            localStorage.removeItem('vms_token');
            localStorage.removeItem('vms_user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;
